import { render, staticRenderFns } from "./TaskDetailsLog.vue?vue&type=template&id=2d40dded"
import script from "./TaskDetailsLog.vue?vue&type=script&lang=js"
export * from "./TaskDetailsLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports